import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLinkedin, FaEnvelope, FaPhone } from "react-icons/fa";
import "../styles/About.css";
import profilePic from "../images/profile-1.jpg";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-container">
      <div className="about-profile">
        <img src={profilePic} alt="Srijan Sareen" className="profile-img" />
        <h1>Srijan Sareen</h1>
        <p className="title">Software Engineer</p>
      </div>

      <div className="about-description">
        <p>
          Hello, I'm Srijan Sareen, a software engineer passionate about full-stack
          development, distributed systems, and cloud computing.
        </p>
        <p>
          I specialize in Java, Python, Django, Spring Boot, Backend Architecture, AWS Services, problem solving, and database optimizations, and I
          love solving complex system design challenges.
        </p>
      </div>

      <div className="contact-icons">
        <a href="https://linkedin.com/in/srijansa" target="_blank" rel="noopener noreferrer">
          <FaLinkedin className="icon linkedin" />
        </a>
        <a href="mailto:srijansa@buffalo.edu">
          <FaEnvelope className="icon email" />
        </a>
        <a href="tel:+1 7166178379">
          <FaPhone className="icon phone" />
        </a>
      </div>

      <button className="back-button" onClick={() => navigate("/")}>
        Back to Home
      </button>
    </div>
  );
};

export default About;
